import React from 'react';
import {
    required,
    Edit, SimpleForm, ReferenceInput, SelectInput,
    BooleanInput, NumberInput
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import moment from "moment";
import * as apiClient from "../../apiClient";
import { CreateToolbar } from "../../CreateToolbar";
import { useStyles } from "../../formStyles";
import { makeStyles } from '@material-ui/core/styles';

const useCustomStyles = makeStyles((theme) => ({
    formContainer: {
        maxHeight: '80vh',  // Limit height to enable scrolling
        overflowY: 'auto',  // Enable vertical scrolling
        padding: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            maxHeight: '70vh', // Adjust for smaller screens
        },
    }
}));

export const EditScoringTypeDetail = props => {
    const classes = useStyles();
    const customClasses = useCustomStyles();

    const initialValues = {
        isActive: true,
        
    };

    const handleSubmit = (formdata) => {
         let userId;
                userId = localStorage.getItem("userId");
                if (userId) {
                  userId = parseInt(userId);
                }
        
                let data={...formdata};
                let m = moment(new Date());
                if(data.createdBy==null)
                    {
                        data.createdBy=userId;
                    }
                    if(data.createdDate==null)
                        {
                            data.createdDate= m.toISOString();
                        }
         
                data. modifyDate=  m.toISOString()
                data. modifyBy=  userId
                apiClient.updateRecord("scoring-type-details", data).then(res => {
                    
                    props.onClose();
                }).catch(err => {
                    console.log(err);
                });
        
    };

    return (
        
            <Edit {...props} id={props.record.id} resource="scoring-type-details" redirect={false}>
            <div className={customClasses.formContainer}>
                <SimpleForm
                    onSubmit={handleSubmit}
                    initialValues={initialValues}
                    toolbar={<CreateToolbar onSave={handleSubmit} label="Save" onClose={props.onCancel} />}
                    variant="outlined"
                >
                    <ReferenceInput label="Heading Type" fullWidth
                        perPage={5000} source="headingId"
                        reference="statuses"
                        filter={{ statusType: 'SCORINGTYPE' }}
                        sort={{ field: 'status', order: 'ASC' }}
                    >
                        <SelectInput optionText="status" variant="outlined" fullWidth validate={[required()]} />
                    </ReferenceInput>

                    {[...Array(5)].map((_, index) => (
                        <RichTextInput key={index} source={`level0${index + 1}`} label={`Level ${index + 1}`} />
                    ))}

                    <NumberInput source="sortingOrder" label="Sorting Order" validate={[required()]} />
                    <BooleanInput source="isActive" label="Is Active" initialValues={true} />
                </SimpleForm>
            </div>
        </Edit>
    );
};
